import { useState } from "react";
import { useAuth } from "../state/auth";
import { Button } from "./ui/button";
import { api } from "../lib/api";
import { Download } from "lucide-react";
import { toast } from "sonner";

/**
 * ExportButton - downloads a CSV from a backend endpoint with Authorization.
 * path: e.g. "/export/reconciliation.csv"
 * params: optional query params
 * filename: default filename for download
 */
export default function ExportButton({ path, params, filename = "export.csv", label = "Export CSV", size = "sm", variant = "outline", testid = "export-csv" }) {
  const { token } = useAuth();
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const res = await api.get(path, { params, responseType: "blob" });
      const blob = new Blob([res.data], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.success(`Downloaded ${filename}`);
    } catch (e) {
      toast.error(`Export failed: ${e.message}`);
    } finally { setBusy(false); }
    // token var just to satisfy hook usage
    void token;
  };

  return (
    <Button size={size} variant={variant} onClick={run} disabled={busy} data-testid={testid}>
      <Download size={14} className="mr-2" /> {busy ? "Exporting…" : label}
    </Button>
  );
}
